import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import {ContextualMenuSlidesOptions} from '@Components/contextual-menu/components/contextual-menu-slides-options';
import {useSingleActivePosterItem} from '@Hooks/poster-editor/useSingleActivePosterItem';
import {useAppSelector} from '@/hooks';

export function SlideshowSlidesOption(): ReactElement<any> {
  const activeItem = useSingleActivePosterItem();
  const isPosterVideo = useAppSelector((state) => {
    return state.posterEditor.isVideo;
  });

  // TODO: NEED TO THINK IF THIS SHOULD EXIST HERE OR NOT
  // TODO: remove from onItemAddedToPage from motion and slideshow classes once this is handled properly
  useEffect((): void => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (currentPage && isPosterVideo && currentPage.background.isTransparentBackground()) {
      currentPage.background.updateBackgroundToBeNonTransparent();
    }
  }, [isPosterVideo]);

  if (!activeItem) {
    throw new Error('Active item does not exist in SlideshowSlidesOption');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, instead got ${activeItem.gitype}`);
  }

  const onChangeIntroDelay = (updatedValue: number): void => {
    activeItem.updateOnPageStartTime(updatedValue, false);
  };

  const onChangeIntroDelayEnded = (updatedValue: number): void => {
    const getAllowedIntroDelayValue = activeItem.getMaxPossibleIntroDelayFromValue(updatedValue);
    activeItem.updateOnPageStartTime(getAllowedIntroDelayValue);
  };

  return (
    <ContextualMenuSlidesOptions
      id="slideshow-slides-option"
      introDelay={activeItem.onPageStartTime}
      onChangeIntroDelayEnded={onChangeIntroDelayEnded}
      onChangeIntroDelay={onChangeIntroDelay}
      numberOfItems={activeItem.slides.getNumberOfSlides()}
    />
  );
}
